<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item prop="time">
            <el-date-picker v-model="filters.time" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportExcel" :loading="excelLoading">文件导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item>

        </el-form>
      </el-col>
      <el-alert title="提示：如不指定日期，默认查询昨天的数据" type="success"></el-alert>
      <template v-for="(model, index) in goods">
        <el-table :data="model.list" :key="index" :header-cell-style="index>0?{ display: 'none' }:{display: 'true'}" :row-class-name="tableRowClassName" highlight-current-row v-loading="loading" style="width: 100%" border>
          <el-table-column prop="groupname" label="区域">
          </el-table-column>
          <el-table-column prop="yeargoal" label="年度销售指标">
          </el-table-column>
          <el-table-column prop="yearPCT" label="年度销售完成比例">
            <template slot-scope="scope">
              {{scope.row.yearPCT}}%
            </template>
          </el-table-column>
          <el-table-column prop="monthgoal" label="月度销售指标"> </el-table-column>
          <el-table-column prop="monthPCT" label="月度销售完成比例">
            <template slot-scope="scope">
              {{scope.row.monthPCT}}%
            </template>
          </el-table-column>
          <el-table-column prop="monthtotal" label="本月销售合计"> </el-table-column>
          <el-table-column prop="premonthtotal" :label="preMonth"> </el-table-column>
          <el-table-column prop="todaytotal" label="当日销售"> </el-table-column>
          <el-table-column prop="yeartotal" label="全年完成销售金额"> </el-table-column>
          <el-table-column prop="preyeartotal" :label="preYear"> </el-table-column>

          <el-table-column prop="allmonthtotal" :label="preDate"> </el-table-column>
          <el-table-column prop="pretodaytotal" label="前一天累计销售"> </el-table-column>
        </el-table>
      </template>
    </el-col>
  </el-row>
</template>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
<script>
import API from "@/api/frsendgoodsapi/monthsale.js";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      excelLoading: false,
      filters: { time: null },
      goods: [],
      preYear: "", //上一年
      preMonth: "", //上一个月
      preDate: "前几个月累计", //前几个月
    };
  },
  methods: {
    exportExcel() {
      const dateParam = this.filters.time
        ? moment(this.filters.time).format("YYYY-MM-DD")
        : null;
      const params = { sendTime: dateParam };

      const param = this.filters.time
        ? moment(this.filters.time).format("YYYY-MM-DD")
        : moment(new Date()).format("YYYY-MM-DD");
      // 定义动态文件名
      const fileName = `月度销售累计_${param}.xlsx`;

      API.exportExcel(params)
        .then((res) => {
          if (res) {
            this.excelLoading = true;
            const content = res;
            const blob = new Blob([content]);
            if (typeof navigator.msSaveBlob !== "undefined") {
              // 兼容IE
              navigator.msSaveBlob(blob, fileName);
            } else {
              // 其他浏览器
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.download = fileName; // 设置文件名
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            }
            this.excelLoading = false;
          }
        })
        .catch((error) => {
          this.excelLoading = false;
          this.$message.error("Excel文件导出失败");
          console.error("Excel文件导出失败：", error);
        });
    },

    //修改某行的颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.depid === 0) {
        return "warning-row";
      }
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    clickUpload() {
      this.$router.push("/sys/frsale/jdjieyu/upload");
    },
    handleSearch() {
      this.search();
    },

    //获取上一个月的日期
    getPreviousMonth(inputDate) {
      const date = new Date(inputDate);
      console.log(date);
      const currentMonth = date.getMonth();
      if (currentMonth === 0) {
        // 当前是 1 月，设置为上一年的 12 月
        date.setFullYear(date.getFullYear() - 1);
        date.setMonth(11);
      } else {
        date.setMonth(date.getMonth() - 1);
      }
      const result = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      return result;
    },

    //自定义表头
    createHeader() {
      const dateH = this.filters.time
        ? moment(this.filters.time).format("YYYY-MM-DD")
        : moment(new Date()).format("YYYY-MM-DD");
      this.preYear = dateH.substring(0, 4) - 1 + "年全年完成"; //上一年

      const pre = this.getPreviousMonth(dateH); //上一个月
      this.preMonth =
        pre.substring(0, 4) + "年" + pre.substring(5, 7) + "月销售";

      this.preDate =
        dateH.substring(5, 7) == 1
          ? "无"
          : "1-" + (dateH.substring(5, 7) - 1) + "月已完成"; //前几个月
    },

    search() {
      this.loading = true;
      //自定义表头
      this.createHeader();
      const dateParam = this.filters.time
        ? moment(this.filters.time).format("YYYY-MM-DD")
        : null;
      const params = { sendTime: dateParam };
      API.list(params)
        .then(
          (result) => {
            this.loading = false;
            this.goods = result.data;
          },
          (err) => {
            this.loading = false;
            this.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(() => {});
    },
  },

  mounted() {
    this.handleSearch();
  },
};
</script>

<style>
.el-table .warning-row {
  background: #f0f9eb;
  color: rgb(248, 141, 141);
}
</style>
